/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PendingNotificationResponse } from "./PendingNotificationResponse";
import type { ScheduledNotificationResponse } from "./ScheduledNotificationResponse";

export interface ScheduledNotificationsResponse {
  scheduled_notifications: ScheduledNotificationResponse[];
  /** Pending notifications (only included in non-production environments) */
  pending_notifications?: PendingNotificationResponse[] | null;
}
